/**
 * Leveled logging.
 *
 * The codebase had ~136 bare `console.log` calls, emoji prefixes and all,
 * printing to every visitor's console -- including the payloads of admin
 * requests. `debug` and `info` are no-ops in a production build; `warn` and
 * `error` always print, because those are the ones worth seeing in the field.
 *
 * The calls themselves are not removed from the bundle, so their arguments are
 * still evaluated. Keep them cheap: no template literals over large objects.
 */
import { env } from '@/config/env';

const verbose = !env.isProduction;

export const logger = {
  debug: (...args: unknown[]) => {
    if (verbose) console.debug(...args);
  },
  info: (...args: unknown[]) => {
    if (verbose) console.info(...args);
  },
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};
